const INITIAL_STATE = {
  data: [],
  task_responsibility: '',
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  GET_TASK_REQUEST: 'task/GET_TASK_REQUEST',
  GET_TASK_SUCCESS: 'task/GET_TASK_SUCCESS',
  SET_TASK_RESPONSIBILITY: 'task/SET_TASK_RESPONSIBILITY',
  GET_TASK_DETAILS_REQUEST: 'task/GET_TASK_DETAILS_REQUEST',
  GET_TASK_DETAILS_SUCCESS: 'task/GET_TASK_DETAILS_SUCCESS',
};

/**
 * Reducer
 */
export default function task(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_TASK_SUCCESS:
      return { ...state, data: action.payload };
    case Types.GET_TASK_DETAILS_SUCCESS:
      return {
        ...state,
        data: state.data.map(taskFilter => (
          taskFilter.task_id === action.payload.id
            ? { ...taskFilter, ...action.payload }
            : taskFilter
        )),
      };
    case Types.SET_TASK_RESPONSIBILITY:
      return { ...state, task_responsibility: action.payload };
    default:
      return state;
  }
}

/**
 * Helpers
 */
export const getTaskByID = (state) => {
  if (state.task.data) {
    return state.task.data;
  }
  return {};
};

/**
 * Actions Creators
 */
export const Creators = {
  getTaskRequest: payload => ({
    type: Types.GET_TASK_REQUEST,
    payload,
  }),
  getTaskSuccess: payload => ({
    type: Types.GET_TASK_SUCCESS,
    payload,
  }),
  getTaskDetailsRequest: idTask => ({
    type: Types.GET_TASK_DETAILS_REQUEST,
    idTask,
  }),
  getTaskDetailsSuccess: payload => ({
    type: Types.GET_TASK_DETAILS_SUCCESS,
    payload,
  }),
  setTaskResponsibility: payload => ({
    type: Types.SET_TASK_RESPONSIBILITY,
    payload,
  }),
};
